import React from 'react';
import { Container } from 'react-bootstrap';
import { getArchivedAnnouncements } from '../../data/announcements';
import './AnnouncementsArchive.css';

const formatDate = (iso) => {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

const AnnouncementsArchive = () => {
  const archived = getArchivedAnnouncements();

  return (
    <div className="announcements-archive-page">
      <Container className="gn-container py-5">
        <h1 className="announcements-archive-title">Announcements &amp; Notices Archive</h1>
        <p className="announcements-archive-intro">
          Past notices and announcements, with end dates for reference.
        </p>
        {archived.length === 0 ? (
          <p className="announcements-archive-empty">No archived announcements yet.</p>
        ) : (
          <ul className="announcements-archive-list">
            {archived.map((item) => (
              <li key={item.id} className="announcements-archive-item">
                <div className="announcements-archive-item-meta">
                  <span className="announcements-archive-eyebrow">{item.eyebrow}</span>
                  <span className="announcements-archive-date">Ended: {formatDate(item.endDate)}</span>
                </div>
                <h3 className="announcements-archive-item-title">{item.title}</h3>
                <p className="announcements-archive-item-desc">{item.description}</p>
              </li>
            ))}
          </ul>
        )}
      </Container>
    </div>
  );
};

export default AnnouncementsArchive;
